module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-popover', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHint),
      expression: "showHint"
    }],
    ref: "popover",
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": _vm.hintValue
    }
  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
    attrs: {
      "label": "temp",
      "prop": _vm.attr.columnName
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    staticClass: "glyphicon glyphicon-question-sign"
  }) : _vm._e()]), _vm._v(" "), _c('MaskedField', {
    attrs: {
      "mask": '##.###.###/####-##',
      "placeholder": '99.999.999/9999-99',
      "attr": _vm.attr
    },
    on: {
      "callBusinessRule": _vm.callBusinessRule
    },
    model: {
      value: (_vm.updateFieldValue),
      callback: function($$v) {
        _vm.updateFieldValue = $$v
      },
      expression: "updateFieldValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.updateFieldValue) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.updateFieldValue) + "\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76d1ec65!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderInputCnpj.vue
// module id = 940
// module chunks = 2